// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module--header--2XY6G","active":"style-module--active--2azzq","inner":"style-module--inner--2wuCe","language":"style-module--language--3Ley5"};